export default {
    preguntasFrecuentes: [],
    comerciosAliados: null,
    layoutPrincipal: {
        navBar: 'nav-bar',
        footer: 'new-footer'
    },
    infoCampaign: null,
    comerciosSoli: null,
}